<template>
  <div>
    <div class="fade-background"></div>
    <div class="delete-alert">
      <div class="fp_container">
        <div class="box-text">{{confirmationMessage}}</div>
        <div class="vcore_row">
          <div class="vcore_col--lg--12">
            <button class="vcore_btn modal-button"
                    :class="{ 'red-button': positive, 'blue-button': !positive }"
                    type="button" @click="confirm(false)">
              {{cancelText}}
            </button>
            <button class="vcore_btn modal-button"
                    :class="{ 'red-button': !positive, 'blue-button': positive }"
                    type="button" @click="confirm(true)">
              {{confirmText}}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ConfirmationModal",
  props: {
    positive: {
      type: Boolean,
      default: true
    },
    cancelText: {
      type: String,
      default: "Cancel"
    },
    confirmText: {
      type: String,
      default: "Confirm"
    },
    confirmationMessage: {
      type: String
    }
  },
  methods: {
    confirm(answer){
      this.$emit("input", answer);
    }
  }
};
</script>

<style lang="scss" scoped>

  .fp_container {
    background-color: rgba(255, 255, 255, 1);
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-top: 12px #2b78e4 solid;
    position: fixed;
    z-index: 5;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 20px 20px 10px;
    margin-bottom: 110px;
    width: 570px;
  }

  .fade-background{
    background-color: #000000;
    opacity: 50%;
    position: fixed;
    top:0px;
    left:0px;
    width: 100%;
    height: 100%;
  }

  .box-text {
    font-family: "Open Sans", sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 24px;
    color: #666666;
    text-align: center;
    margin-bottom: 15px;
  }

  .modal-button {
    font-size: 18px;
    font-weight: 600;
    padding: 10px 30px;
    min-width: 150px;
    margin: 10px;
  }

</style>
